import CityPage from "../CityPage";

export default function ElmwoodPark() {
  return <CityPage slug="elmwood-park" />;
}
